import React from "react";
import { NavLink } from "react-router-dom";
const NavItem = (props) => {
  return (
    <NavLink
      to={props.link}
      className="flex gap-1 items-center cursor-pointer h-[62px] border-b-2 border-transparent "
    >
      <div className=" w-8 h-7 grid place-items-center bg-[var(--LColor)] rounded-lg">
        {props.icon}
      </div>
      <span className=" text-xl">{props.text}</span>
    </NavLink>
  );
};

export default NavItem;
